import LottieRaw from 'lottie-react';
import data from './smiley.correct.json.js';
import { jsx } from 'react/jsx-runtime';

const Lottie = LottieRaw.default ?? LottieRaw;
function CorrectSmileyIcon(props) {
  return /*#__PURE__*/jsx(Lottie, {
    loop: false,
    ...props,
    animationData: data
  });
}
CorrectSmileyIcon.blink = lottie => {
  if (!lottie || !lottie.animationItem) {
    return;
  }
  if (lottie.animationItem.currentFrame >= lottie.animationItem.totalFrames - 1) {
    lottie.goToAndPlay(90, true);
  }
};

export { CorrectSmileyIcon };
//# sourceMappingURL=smiley.correct.js.map
